// DRAFT — REVIEW ARTIFACT — NOT DEPLOYED
//
// The Brinson attribution table (R range: the time-weighted, snapshot-trap-corrected
// reconcile). Allocation / selection / total decompose the gap vs the composite, with the
// fraction of the actual gap the model explains. Sign-tone rides on the number so a drag is
// unmistakable. not_found cells (Property/Alternatives residual) render their sentinel.

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import type { BrinsonLevel } from "@/types/ir";
import { CellValue } from "./CellValue";
import { EmptyState } from "@/components/research-hub";

export function AttributionTable({
  brinsonR,
  caption,
}: {
  brinsonR: Record<string, BrinsonLevel> | undefined;
  caption?: string;
}) {
  const rows = brinsonR ?? {};
  const keys = Object.keys(rows).filter((k) => !k.startsWith("_"));
  if (keys.length === 0) return <EmptyState title="No attribution decomposition in this cycle yet." />;

  return (
    <div className="space-y-2">
      {caption && <p className="font-body text-xs text-muted-foreground">{caption}</p>}
      <div className="overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Level</TableHead>
              <TableHead className="text-right">Allocation</TableHead>
              <TableHead className="text-right">Selection</TableHead>
              <TableHead className="text-right">Total</TableHead>
              <TableHead className="text-right">Actual gap</TableHead>
              <TableHead className="text-right">% explained</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {keys.map((k) => {
              const lvl = rows[k];
              return (
                <TableRow key={k}>
                  <TableCell className="font-body font-medium">{k}</TableCell>
                  <TableCell className="text-right"><CellValue cell={lvl.allocation} signed /></TableCell>
                  <TableCell className="text-right"><CellValue cell={lvl.selection} signed /></TableCell>
                  <TableCell className="text-right"><CellValue cell={lvl.total} signed /></TableCell>
                  <TableCell className="text-right"><CellValue cell={lvl.actual_gap} signed /></TableCell>
                  <TableCell className="text-right"><CellValue cell={lvl.pct_explained} digits={0} /></TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
